import { contextFactory } from '../../hooks/context-factory';
import type { TextProps } from '../text/text.component';

export interface BreadcrumbsProps {
  children: React.ReactNode;
  size?: TextProps['size'];
}

interface BreadcrumbsContext {
  size?: TextProps['size'];
}

export const [BreadcrumbsContext, useBreadcrumbs] = contextFactory<BreadcrumbsContext>();

export function BreadcrumbsProvider({ children, size }: BreadcrumbsProps) {
  return (
    <BreadcrumbsContext.Provider
      value={{
        size,
      }}
    >
      {children}
    </BreadcrumbsContext.Provider>
  );
}
